import AddressAutocomplete from "components/AddressAutocomplete/AddressAutocomplete";
import { isEmailValidAndPresent } from "helpers/validators";
import { ElectricityAgreementForm } from "models/electricity/new-electricity-agreement";
import React from "react";
import { Form } from "react-bootstrap";


export default function NewElectricityAgreementCustomerForm(
    { isCompany, form, setForm, isFormDisabled, showConsolidatedInvoiceCheckbox }:
    { isCompany: boolean, form: ElectricityAgreementForm, setForm: any, isFormDisabled: boolean, showConsolidatedInvoiceCheckbox: boolean }
) {

    return (
        <>
        <Form noValidate validated={form.validated}>
            <div className="row">
                <div className="col-12 col-md-6">
                    <Form.Label className={'mb-0 align-self-start m-1 text-center'}>
                        <span className="text-nowrap">{ isCompany ? 'Ettevõtte nimi' : 'Nimi' }</span>
                    </Form.Label>                    
                    <Form.Control
                        value={form.customerName}
                        disabled={true}
                        type="text"
                    />
                </div>
                <div className="col-12 col-md-6 mt-3 mt-lg-0">
                    <Form.Label className={'mb-0 align-self-start m-1 text-center'}>
                        <span className="text-nowrap">{ isCompany ? 'Registrikood' : 'Isikukood' }</span>
                    </Form.Label>
                    <Form.Control
                        value={form.registryNumber}
                        disabled={true}
                        type="text"
                    />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12 col-md-6 mt-3 mt-lg-0">
                    <Form.Label className={'mb-0 align-self-start m-1 text-center'}>
                        <span className="text-nowrap">Kontakttelefon</span>
                    </Form.Label>
                    <Form.Control
                        required
                        value={form.phone}
                        disabled={isFormDisabled}
                        onChange={(e) => setForm({ ...form, phone: e.target.value })}
                        type="tel"
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
                <div className={"col-12 col-md-6 mt-3 mt-lg-0"}>
                    <Form.Label className={'mb-0 align-self-start m-1 text-center'}>
                        <span className="text-nowrap">E-post</span>
                    </Form.Label>                    
                    <Form.Control
                        required
                        value={form.email}
                        disabled={isFormDisabled}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        isInvalid={form.validated && !isEmailValidAndPresent(form.email)}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
                <div className="col-12 col-xxl-6 mt-3">
                    <Form.Label className={'mb-0 align-self-start m-1 text-center'}>
                        <span className="text-nowrap">Postiaadress</span>
                    </Form.Label>
                    <AddressAutocomplete
                        address={form.address}
                        setAddress={(address) => setForm({
                            ...form,
                            address: address.fullAddress || address.address,
                            city: address.city,
                            zip: address.zip,
                            county: address.county
                        })}
                        disabled={isFormDisabled}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
            </div>
        </Form>
        { showConsolidatedInvoiceCheckbox ? <div className="row my-4">
            <div className="col">
                <Form.Check
                    id='check-consolidated-invoice'
                    custom
                    type="checkbox"
                    className='checkbox-large'
                    label='Soovin koondarvet'
                    onChange={() => setForm({ ...form, consolidatedInvoice: !form.consolidatedInvoice })}
                    checked={form.consolidatedInvoice}
                />
            </div>
        </div> : null }
        </>
    )
}